<template>
  <div>
    <div class="row">
      <div v-for="(item, index) in titlesToCheck" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3">
        <b-link v-if="item === 'ประกาศชุมชน'" :to="{ name: 'announceinfor' }">
          <statistic-card-horizontal :color="color" icon="BellIcon" :statistic-title="`${announce.length} รายการ`" :badge="String(announce.length)" statistic="ประกาศชุมชน" />
        </b-link>

        <b-link v-if="item === 'ข้อมูลท่องเที่ยว'" :to="{ name: 'travelinfor' }">
          <statistic-card-horizontal :color="color" icon="MapIcon" :statistic-title="`${travel.length} รายการ`" :badge="String(travel.length)" statistic="ข้อมูลท่องเที่ยว" />
        </b-link>

        <b-link v-if="item === 'ข้อมูลธุรกิจ'" :to="{ name: 'businessinfor' }">
          <statistic-card-horizontal :color="color" icon="BriefcaseIcon" :statistic-title="`${business.length} รายการ`" :badge="String(business.length)" statistic="ข้อมูลธุรกิจ" />
        </b-link>

        <b-link v-if="item === 'ข้อมูลบริการ'" :to="{ name: 'serviceinfor' }">
          <statistic-card-horizontal :color="color" icon="BookOpenIcon" :statistic-title="`${service.length} รายการ`" :badge="String(service.length)" statistic="ข้อมูลบริการ" />
        </b-link>

        <b-link v-if="item === 'ฉุกฉิน S.O.S'" :to="{ name: 'inform' }">
          <statistic-card-horizontal :color="color" icon="AlertTriangleIcon" :statistic-title="`${inform.length} รายการ`" :badge="String(inform.length)" statistic="แจ้งเหตุ" />
        </b-link>
        <b-link v-if="item === 'แจ้งซ่อมบำรุง'" :to="{ name: 'maintenance' }">
          <statistic-card-horizontal :color="color" icon="ToolIcon" :statistic-title="`${maintenance.length} รายการ`" :badge="String(maintenance.length)" statistic="แจ้งซ่อมบำรุง" />
        </b-link>
        <b-link v-if="item === 'ร้องเรียน'" :to="{ name: 'appeal' }">
          <statistic-card-horizontal :color="color" icon="ArchiveIcon" :statistic-title="`${appeal.length} รายการ`" :badge="String(appeal.length)" statistic="ร้องเรียน" />
        </b-link>
        <b-link v-if="item === 'ผู้มาติดต่อ/นัดหมาย'" :to="{ name: 'historyMeet' }">
          <statistic-card-horizontal :color="color" icon="CalendarIcon" :statistic-title="`${Number(meetTingCount)} รายการ`" :badge="String(meetTingCount)" statistic="ประวัติการเข้าพบ" />
        </b-link>

        <!-- <b-link class="col-12 col-sm-6 col-md-4 col-lg-3" :to="{ name: 'addMeet' }">
        <statistic-card-horizontal :color="color" icon="CalendarIcon" statistic="สร้างนัดหมาย" />
      </b-link>

       <div class="col-12 col-md-4 col-lg-3"></div>
      <div class="col-12 col-md-4 col-lg-3"></div>
      <div class="col-12 col-md-4 col-lg-3"></div>
      <div class="col-12 col-md-4 col-lg-3"></div>
      <div class="col-12 col-md-4 col-lg-3"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
  import API from '@/connect/config';
  import axios from 'axios';
  import dayjs from 'dayjs';
  export default {
    components: {
      StatisticCardHorizontal,
    },
    data() {
      return {
        color: 'primary',
        //announce
        announce: [],
        travel: [],
        business: [],
        service: [],

        //ticket
        inform: [],
        maintenance: [],
        appeal: [],
        //appointment
        meetTingCount: '',
        titlesToCheck: [],
        titlesChecks: ['ประกาศชุมชน', 'ผู้มาติดต่อ/นัดหมาย', 'แจ้งซ่อมบำรุง', 'ร้องเรียน', 'ข้อมูลธุรกิจ', 'ข้อมูลบริการ', 'ข้อมูลท่องเที่ยว', 'ฉุกฉิน S.O.S'],
      };
    },
    async created() {
      this.resData_announce();
      this.resData_ticket();
      this.resData_meeting();
      await this.titlesCheck();
    },
    methods: {
      async titlesCheck() {
        const jwt = JSON.parse(localStorage.getItem('company_jwt_vis'));
        const headers = {
          Authorization: localStorage.getItem('refresh_token'),
        };
        const res = await axios.get(`${API}features/${jwt.userId}`, headers);

        // const matchedTitles = res.data.message.result[0].featuresData;
        const matchedTitles = this.titlesChecks.filter((item) => res.data.message.result[0].featuresData.includes(item));
        console.log(matchedTitles);
        this.titlesToCheck.push(...matchedTitles);
        // console.log(this.titlesToCheck);
      },
      resData_meeting() {
        const { userId } = JSON.parse(localStorage.getItem('company_jwt_vis'));
        let uId = JSON.parse(localStorage.getItem('profile_visitor')).userId;
        axios
          .get(`${API}meeting/${userId}?uId=${uId}`)
          .then((res) => {
            let i = 0;
            res.data.message.result.map((el, index) => {
              if (uId == el.uId) {
                i++;
                this.meetTingCount = i;
              }
            });
          })
          .catch((err) => {
            console.error('failed', err);
          });
      },
      resData_announce() {
        this.$store.dispatch('get_announce_filter', `no_category`).then(async (res) => {
          // tag.forEach((el, index) => {
          //   res.forEach((el2) => {
          //     console.log(el2.tag);
          //     el2.tag.forEach((el3) => {
          //       //    console.log(el);
          //       //   console.log(el3)
          //       if (el3 == el) {
          //         console.log(el2);
          //         data.push(el2);
          //       }
          //     });
          //   });
          // });
          // console.log(res);
          res.forEach((el, index) => {
            if (el.category == 'announce') {
              if (dayjs().isAfter(dayjs(el.showDate))) {
                this.announce.push(el);
              }
            }
            if (el.category == 'travel') {
              this.travel.push(el);
            }
            if (el.category == 'business') {
              this.business.push(el);
            }
            if (el.category == 'service') {
              this.service.push(el);
            }
          });
        });
      },
      resData_ticket() {
        const { userId, uId } = JSON.parse(localStorage.getItem('company_jwt_vis'));

        this.$store.dispatch('getData', `ticket/${userId}?uId=${uId}&_page=1&_limit=100`).then(async (res) => {
          res.message.result.forEach((el, index) => {
            if (el.type == 'inform') {
              this.inform.push(el);
            }
            if (el.type == 'maintenance') {
              this.maintenance.push(el);
            }
            if (el.type == 'appeal') {
              this.appeal.push(el);
            }
          });
        });
      },
    },
  };
</script>

<style></style>
